import {
  runEmbeddedSignup,
  preloadFacebookSdk,
  POPUP_ERROR_NAME,
  SIGNUP_ABORTED,
} from './embeddedSignupUtils';

// Comparte entre el alta y la reconexión el ciclo de vida del popup de Meta: precarga el SDK
// cuando el componente lo pide, guarda la corrida activa, la cancela si el componente se destruye
// con el popup abierto y lee el error que devuelve el backend o el propio popup. Quien lo usa
// debe ignorar los rechazos marcados como abortados. Un componente con la opción
// `keepSignupOnDestroy: true` deja viva la corrida para terminarla aunque el usuario salga.
export default {
  created() {
    // Fuera de data(): la promesa no necesita ser reactiva.
    this.signupRun = null;
  },
  // Cancela la corrida abierta salvo que el componente pida terminarla igual.
  beforeDestroy() {
    if (this.signupRun && !this.$options.keepSignupOnDestroy) {
      this.signupRun.cancel();
    }
  },
  methods: {
    // Deja el SDK listo antes del clic: el popup solo abre dentro de la ventana de activación del
    // usuario y una descarga del SDK en ese momento la agota. Cada componente decide cuándo
    // llamarlo, para no descargar el SDK en pantallas donde quizá nadie pulse el botón.
    preloadSignupSdk() {
      preloadFacebookSdk();
    },
    // Abre el popup y espera su resultado; solo una corrida a la vez. options va tal cual a
    // runEmbeddedSignup (modo coexistencia o normal).
    async runSignup(options) {
      this.signupRun = runEmbeddedSignup(options);
      try {
        return await this.signupRun;
      } finally {
        this.signupRun = null;
      }
    },
    // true cuando el rechazo vino de cancelar la corrida, no de un fallo real.
    isSignupAborted(error) {
      return Boolean(error) && error.message === SIGNUP_ABORTED;
    },
    // Mensaje de error del backend (422 con { error }), o null si no lo hay.
    signupApiError(error) {
      return error && error.response && error.response.data
        ? error.response.data.error
        : null;
    },
    // Mensaje que Meta mostró en el popup al fallar, o null si el error no vino de ahí.
    signupPopupError(error) {
      return error && error.name === POPUP_ERROR_NAME ? error.message : null;
    },
  },
};
